import React, { Component } from 'react';
import {Modal, Button, Container, Row, Col, Tab, Table} from 'react-bootstrap';
import Datas from '../../data/shop/details.json';
import HeaderTwo from '../../components/HeaderTwo';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/productDetails.js';
import {Link} from "react-router-dom";
import { withTranslation } from 'react-i18next';

class ProductDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filteredData: [],
            showModal: false,
            selectedImage: '',
            selectedProductName: '',
            redirectToProductCategory: false,
        };
    }

    componentDidMount() {
        const product_id = this.props.match.params.product_id;
        this.filterProducts(product_id);
        
        // Ensure mobile menu is properly initialized on direct page refresh
        // Try immediately first
        this.initializeMobileMenu();
        
        // Also try after a short delay as backup
        setTimeout(() => {
            this.initializeMobileMenu();
        }, 100);
        
        // Final attempt after longer delay
        setTimeout(() => {
            this.initializeMobileMenu();
        }, 500);
    }

    componentDidUpdate(prevProps) {
        const prevProductName = prevProps.match.params.product_id;
        const currentProductName = this.props.match.params.product_id;

        if (prevProductName !== currentProductName && !this.state.filteredData.length) {
            this.filterProducts(currentProductName);
        }
    }

    filterProducts(product_id) {
        const filteredData = Datas.filter((product) => product.product_id === product_id && product.status === "1");

        if (filteredData.length === 0 && !this.state.redirectToProductCategory) {
            this.setState({ redirectToProductCategory: true });

            this.props.history.push(`${process.env.PUBLIC_URL}/product-category`);
            window.location.reload();
        } else {
            this.setState({ filteredData });
        }
    }

    openModal = (image, productName) => {
        this.setState({ showModal: true, selectedImage: image, selectedProductName: productName });
    }

    closeModal = () => {
        this.setState({ showModal: false });
    }

    initializeMobileMenu = () => {
        // Re-initialize mobile menu to ensure it works on direct page refresh
        const mobileMenuArea = document.querySelector('.mobile-menu-area');
        const hmBtn = document.getElementById("mb-sidebar-btn");
        
        // Force mobile menu area to be visible on mobile screens
        if (mobileMenuArea && window.innerWidth <= 767) {
            mobileMenuArea.style.display = 'block';
            mobileMenuArea.style.background = '#182B49';
        }
        
        if (hmBtn) {
            const mdSidebarOverlay = document.getElementById("mb-sidebar-overlay");
            const mdSidebarBody = document.getElementById("mb-sidebar-body");
            
            // Force hamburger button to be visible
            hmBtn.style.display = 'inline-block';
            hmBtn.style.padding = '8px 12px';
            hmBtn.style.cursor = 'pointer';
            
            const hamburgerIcon = hmBtn.querySelector('i');
            if (hamburgerIcon) {
                hamburgerIcon.style.display = 'inline-block';
                hamburgerIcon.style.fontSize = '20px';
                hamburgerIcon.style.color = '#11B67A';
            }
            
            // Ensure styles are applied to sidebar
            if (mdSidebarBody) {
                mdSidebarBody.style.display = 'block';
                mdSidebarBody.style.background = '#ffffff';
                mdSidebarBody.style.zIndex = '99999';
            }
            
            if (mdSidebarOverlay) {
                mdSidebarOverlay.style.zIndex = '9998';
            }
            
            // Force style application for menu items
            const menuLinks = document.querySelectorAll('.mb-sidebar .mb-menu-content a');
            menuLinks.forEach(link => {
                link.style.color = '#182B49';
                link.style.fontSize = '14px';
                link.style.fontWeight = '500';
                link.style.textDecoration = 'none';
                link.style.display = 'block';
                link.style.padding = '10px 0 10px 15px';
            });
        }
    }

    render() {
        const { filteredData, redirectToProductCategory, showModal, selectedImage, selectedProductName } = this.state;
        const { t } = this.props;

        if (redirectToProductCategory) {
            return null;
        }

        return (
            <Styles>
                {/* Main Wrapper */}
                <div className="main-wrapper ">

                    {/* Header 2 */}
                    <HeaderTwo />

                    {/* Product Details */}
                    <section className="product-details-page product-details-area">
                        <Container>
                            <Row>
                                <Col md="12">
                                    {filteredData.length > 0 && (
                                        <nav aria-label="breadcrumb">
                                            <ol className="breadcrumb">
                                                <li className="breadcrumb-item"><Link to={process.env.PUBLIC_URL + "/"}>Home</Link></li>
                                                <li className="breadcrumb-item"><Link to={`${process.env.PUBLIC_URL}/product-category`}>Products</Link></li>
                                                <li className="breadcrumb-item"><Link to={`${process.env.PUBLIC_URL}/products/${filteredData[0].category_id}`}>{filteredData[0].category_name}</Link></li>
                                                <li className="breadcrumb-item active" aria-current="page"><strong>{filteredData[0].product_name}</strong></li>
                                            </ol>
                                        </nav>
                                    )}
                                </Col>
                            </Row>
                            {filteredData.length > 0 ? (
                                filteredData.map((data, i) => (
                                    <Row key={i}>
                                        <Col md="5">
                                            <div className="product-slider">
                                                <div className="slider-item">
                                                    <div className="zoom-container">
                                                        <button
                                                            className="zoom-btn"
                                                            onClick={() => this.openModal(process.env.PUBLIC_URL + `/assets/images/${data.productImg}`, data.product_name)}
                                                            aria-label="Zoom In"
                                                        >
                                                            <span role="img" aria-label="Zoom In">🔍</span>
                                                        </button>
                                                        <img
                                                            src={process.env.PUBLIC_URL + `/assets/images/${data.productImg}`}
                                                            alt={data.product_name}
                                                            className="img-fluid"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>

                                        <Col md="7">
                                            <div className="product-information">
                                                <div className="product-title">
                                                    <h4>{data.product_name}</h4>
                                                </div>
                                                <div className="product-stock">
                                                    <p>{t('shop.category')} : <span className="stock">{t(`shop.categories.${data.category_id}`)}</span></p>
                                                </div>
                                            </div>
                                            <div className="product-tab">
                                                <Tab.Container defaultActiveKey="additional">
                                                    <Tab.Content>
                                                        <Tab.Pane eventKey="additional" className="additional-tab">
                                                            <Table className="table table-bordered">
                                                                <tbody>
                                                                <tr>
                                                                    <td>{t('shop.product_id')}</td>
                                                                    <td>{data.product_name}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{t('shop.fabric')}</td>
                                                                    <td>{data.fabric}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{t('shop.material')}</td>
                                                                    <td>{data.material}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{t('shop.size')}</td>
                                                                    <td>{data.size}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{t('shop.color')}</td>
                                                                    <td>{data.color}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{t('shop.style')}</td>
                                                                    <td>{data.style}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{t('shop.label')}</td>
                                                                    <td>{data.label}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{t('shop.moq')}</td>
                                                                    <td>{data.moq}</td>
                                                                </tr>
                                                                </tbody>
                                                            </Table>
                                                        </Tab.Pane>
                                                    </Tab.Content>
                                                </Tab.Container>
                                            </div>
                                        </Col>

                                        <Col md="12"></Col>
                                    </Row>
                                ))
                            ) : (
                                <p>{t('shop.no_details')}</p>
                            )}
                        </Container>
                    </section>

                    {/* Footer 2 */}
                    <FooterTwo />
                </div>

                <Modal show={showModal} onHide={this.closeModal} centered size="lg" aria-labelledby="product-image-modal">
                    <Modal.Header closeButton>
                        <Modal.Title id="product-image-modal">{selectedProductName}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="modal-image-container">
                            <img src={selectedImage} alt="Zoomed Product" className="img-fluid" />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.closeModal}>
                            {t('shop.close')}
                        </Button>
                    </Modal.Footer>
                </Modal>

                {showModal && (
                    <div className="modal-overlay" onClick={this.closeModal}></div>
                )}
            </Styles>
        );
    }
}

export default withTranslation()(ProductDetails);